import { useEffect, useState } from 'react'
import clsx from 'clsx'
import Image from 'next/image'

/* styles */
import styles from './_.module.css'

interface Props {
  title: string
  list: {
    title: string
    image?: StrapiImageFile
    color: string
    tag: string | undefined
  }[]
}

function UseCase({ title, list }: Props) {
  const [activeTab, setActiveTab] = useState<string | undefined>(list[0].tag)

  const filteredData = list.filter(item => item.tag === activeTab)

  // Check if the list has been updated and if the activeTab is not in the new list
  useEffect(() => {
    if (list && list.length > 0 && !list.some(item => item.tag === activeTab)) {
      setActiveTab(list[0].tag)
    }
  }, [list, activeTab])

  return (
    <section className="font-heading">
      <div className="container | py-10 md:py-18">
        <h3
          className="text-3xl md:text-5xl font-semibold | max-w-col-9"
          dangerouslySetInnerHTML={{ __html: title }}
        />
      </div>
      <div className="md:container | pb-10 md:pb-18">
        <div className="bg-gray-10 border border-t border-b border-blue-20 md:bg-white md:border-none">
          <div className="flex justify-start md:justify-between md:bg-gray-10 md:border md:border-blue-20 | whitespace-nowrap overflow-auto md:rounded-xl | py-2 px-3 md:mb-14">
            {list.map(item => (
              <button
                key={item.title}
                onClick={() => {
                  setActiveTab(item.tag)
                }}
              >
                <div
                  className={clsx(
                    'font-body text-sm md:text-xl hover:text-white hover:bg-blue-web-50 | rounded-xl px-14 py-2',
                    activeTab === item.tag
                      ? 'font-medium text-white bg-blue-web-50 px-14 py-2'
                      : 'text-blue-web-90'
                  )}
                >
                  {item.tag}
                </div>
              </button>
            ))}
          </div>

          {filteredData.map(item => (
            <div
              key={item.tag}
              className={clsx(
                'grid grid-cols-1 md:grid-cols-12 md:gap-8 bg-gray-10 md:border md:border-blue-20 | md:rounded-xl',
                styles.animate
              )}
            >
              <div className="md:col-span-6 | flex items-center mx-auto max-w-col-5 p-6 md:px-5 md:pt-0 md:pb-0 | order-2 md:order-1">
                <div
                  className="text-2xl md:text-3xl font-medium"
                  dangerouslySetInnerHTML={{ __html: item.title }}
                />
              </div>
              <div
                className="md:col-span-6 | md:rounded-tr-xl md:rounded-br-xl order-1 md:order-2"
                style={{ background: item.color }}
              >
                {item.image?.url ? (
                  <Image
                    src={item.image.url}
                    alt={item.image.alternativeText ?? ''}
                    width={item.image.width}
                    height={item.image.height}
                    className="p-8"
                  />
                ) : null}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default UseCase
